import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export class ControlMixin extends Vue {
	switchAttrs = {
		inset: true,
		dense: true,
		hideDetails: true,
		color: 'primary darken-1',
	};

	radioAttrs = {
		color: 'primary darken-1',
		class: 'body-text',
	};

	checkboxAttrs = {
		color: 'primary darken-1',
		hideDetails: true,
	};

	checkboxHideDetailsAttrs = {
		color: 'primary darken-1',
		class: 'ma-0 pa-0 rounded',
		hideDetails: true,
	};

	// peach color for login / signup
	peachRadioAttrs = {
		color: 'peach',
	};

	peachCheckboxAttrs = {
		color: 'peach',
	};
}
